// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"0ede6c2a","240":"d4ecda58","376":"39e669a4","756":"201aad75","873":"d1f2b9d4","929":"a8b18579"}[chunkId] + ".chunk.js";
};